import React, {Component, ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {
    ContentsMainTitle,
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    IconFont,
    MainContainer,
} from '../../../styledComponents/ContentsArea'
import {StyledDiv, StyledI, StyledImg} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {generateMedia} from 'styled-media-query'
import {BreakPoint} from '../../../styledComponents/Constants'
import {THREAD_CATEGORY} from '../../../CodeMaster'
import {Box} from '@mui/material'
import {
    getFileExtension,
    getFileIconPath,
    getThreadContributorLabelFromSession,
    NatAsyncCallFunction,
} from '../../common/util/Natutil'
import NatBulletinBoardRepo from './repository/NatBulletinBoardRepo'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {PrimaryStyledButton, SecondaryButton} from '../../../styledComponents/Button'
import {
    DisplayBlockDiv,
    DisplayItemDiv,
    DisplayItemInputLabel,
    DisplayItemTitle,
} from '../../../styledComponents/DisplayItem'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {NatPostBulletinBoardThreadCommentConfirmParams} from './repository/NatPostBulletinBoardThreadCommentConfirm'
import {Messages} from '../../../Messages'
import {NatPostBulletinBoardThreadCommentSession} from './repository/NatPostBulletinBoardThreadCommentSession'
import {Location, useLocation} from 'react-router-dom'

function withRouter<P extends object>(
    WrappedComponent: React.ComponentType<P>,
): React.FC<P> {
    function RouterWrapper(props: P): JSX.Element {
        const location = useLocation()
        return <WrappedComponent{...props} location={location}/>
    }

    return RouterWrapper
}

interface Props {
    threadCategoryId: string
    threadId: string
    bulletinBoardRepo: NatBulletinBoardRepo
    location: Location<NatPostBulletinBoardThreadCommentConfirmParams>
}

interface States {
    isLoadCompleted: boolean
}

class NatResidentBulletinBoardThreadCommentConfirmPage extends Component<Props & ResidentPagePropsSet, States> {
    threadCommentConfirmParamsState: NatPostBulletinBoardThreadCommentConfirmParams | null

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            isLoadCompleted: false,
        }

        const locationState = this.props.location.state
        this.threadCommentConfirmParamsState = (locationState) ? locationState : null

        if (!locationState) {
            window.location.href = `/resident/error`
            return
        }

        this.clickRegisterButton = this.clickRegisterButton.bind(this)
        this.clickBackButton = this.clickBackButton.bind(this)

    }

    async componentDidMount(): Promise<void> {
        this.setState({isLoadCompleted: true})
    }


    async clickRegisterButton(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {

            const ret: Nullable<NatPostBulletinBoardThreadCommentSession> =
                await NatAsyncCallFunction(this.props.bulletinBoardRepo.postBulletinBoardThreadCommentSession.bind(
                    this.props.bulletinBoardRepo), this.props.navigate)

            if (ret) {
                // const params = this.threadCommentConfirmParamsState as any;
                // const threadIdToSend = params?.threadCommentConfirmParamsState?.threadId ??
                //     params?.threadId ??
                //     params?.threadCommentConfirmParamsState?.threadCommentConfirmParamsState?.threadId;
                this.props.navigate(
                    `/resident/bulletinBoardThread/${this.threadCommentConfirmParamsState!.threadId}`,
                    {
                        state: {initialMessage: Messages.INTFR0002.toString()},
                        // state: {
                        //     initialMessage: Messages.INTFR0002.toString(),
                        //     threadId: threadIdToSend,
                        //     threadCommentConfirmParamsState: params?.threadCommentConfirmParamsState ??
                        //         params?.threadCommentConfirmParamsState?.threadCommentConfirmParamsState ??
                        //         params,
                        // }
                    },
                )
            }

        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                this.props.navigate(
                    `/resident/error`,
                    {
                        state: {
                            message: errorResponseBody.requestError.message,
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    clickBackButton(): void {
        const params = this.threadCommentConfirmParamsState as any
        this.props.navigate(
            `/resident/bulletinBoardThreadCommentRegister/${this.props.threadCategoryId}/${this.props.threadId}`,
            {
                state: params?.threadCommentConfirmParamsState ??
                    params,
            },
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        // const state = this.props.location.state as unknown as {
        //     threadCommentConfirmParamsState: {
        //         comment: string;
        //         commentImage?: {
        //             fileName: string;
        //             fileSize: number;
        //             fileData: string;
        //         }[];
        //         commentFile?: {
        //             fileName: string;
        //             fileSize: number;
        //             fileData: string;
        //             publishFileName?: string;
        //             sortOrder?: number;
        //         }[];
        //     };
        // } | null
        const images = this.threadCommentConfirmParamsState?.commentImage ?? []
        const hasImages = images.length > 0
        const files = this.threadCommentConfirmParamsState?.commentFile ?? []
        const hasFiles = files.length > 0
        const comment = this.threadCommentConfirmParamsState?.comment ?? ''
        return <>
            <ContentsMainTitle><TitleIcon/>情報交換掲示板</ContentsMainTitle>
            <ContentsSubTitleWrapper>
                <ContentsSubTitleInner>
                    {THREAD_CATEGORY.codeToEnumConstants(this.props.threadCategoryId).label}
                </ContentsSubTitleInner>
            </ContentsSubTitleWrapper>

            <MainContainer>
                <DisplayItemTitle>コメント内容確認</DisplayItemTitle>
                <BlockSpacer height={'20px'}/>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>名前</DisplayItemInputLabel>
                    <DisplayItemDiv>{getThreadContributorLabelFromSession()}</DisplayItemDiv>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>内容</DisplayItemInputLabel>
                    <DisplayItemDiv>
                        <div dangerouslySetInnerHTML={{__html: comment}}/>
                    </DisplayItemDiv>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>画像</DisplayItemInputLabel>
                    {hasImages ? (
                        <Box mt={'8px'}>
                            <ImageList>
                                {images.map((commentImage, key) => (
                                    <ImageDiv key={key}>
                                        <ImageImg src={String(commentImage.fileData)} alt={commentImage.fileName}/>

                                    </ImageDiv>
                                ))}
                            </ImageList>
                        </Box>) : (<></>
                    )}
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>ファイル</DisplayItemInputLabel>
                    {hasFiles ? (
                        files.map((commentFile, index) => (
                            <DisplayItemFileDiv key={index}>
                                <FileIcon src={getFileIconPath(getFileExtension(commentFile.fileName))}
                                          alt={commentFile.fileName}/>
                                <DisplayItemFileInfosDiv>
                                    <DisplayItemFileNameDiv>{commentFile.publishFileName ?? commentFile.fileName}
                                    </DisplayItemFileNameDiv>
                                    {commentFile.sortOrder !== undefined && (
                                        <DisplayItemFileSortOrderLabelDiv>
                                            {`並び順　${commentFile.sortOrder}`}
                                        </DisplayItemFileSortOrderLabelDiv>)}
                                </DisplayItemFileInfosDiv>
                            </DisplayItemFileDiv>
                        ))) : (<></>
                    )}
                </DisplayBlockDiv>

            </MainContainer>

            <Box mt={'30px'} mb={'15px'}>
                <PrimaryStyledButton
                    onClick={this.clickRegisterButton}
                    disabled={false}>
                    コメントを投稿する
                </PrimaryStyledButton>
            </Box>
            <Box mb={'15px'}>
                <SecondaryButton
                    onClick={this.clickBackButton}
                    disabled={false}>
                    修正する
                </SecondaryButton>
            </Box>
        </>
    }
}

export default createResidentPage(withRouter(NatResidentBulletinBoardThreadCommentConfirmPage))

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

const TitleIcon: StyledI = styled.i`
    ${IconFont};
    font-size: 6.0rem;
    padding-right: 15px;
    color: #4dba78;

    &::before {
        content: "\f111";
    }
`

const DisplayItemFileDiv = styled(DisplayItemDiv)`
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const FileIcon: StyledImg = styled.img`
    max-width: 50%;
    ${breakPoint.lessThan('sp')`
    max-width: 150%;
  `}
`

const DisplayItemFileIconDiv = styled(DisplayItemDiv)`
    flex-basis: 20%;
    ${breakPoint.lessThan('sp')`
    margin-left: 0;
  `}
`

const DisplayItemFileNameDiv = styled(DisplayItemDiv)`
    flex-basis: 60%;
    ${breakPoint.lessThan('sp')`
    flex-basis: 100%;
    padding-left: 10px;
  `}
`

const DisplayItemFileSortOrderLabelDiv = styled(DisplayItemDiv)`
    flex-basis: 20%;
    ${breakPoint.lessThan('sp')`
    flex-basis: 100%;
    padding-left: 10px;
  `}
`

const ImageList: StyledDiv = styled.div`
    width: 100%;
    float: left;
`

const ImageDiv: StyledDiv = styled.div`
    display: inline;
    width: calc(100% / 4);
    padding: 8px;
    box-sizing: border-box;
    float: left;
    ${breakPoint.lessThan('sp')`
    width: 100%;
 `}
`

const ImageImg: StyledImg = styled.img`
    max-width: 100%;
    height: auto;
`

const DisplayItemFileInfosDiv = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center ${breakPoint.lessThan('sp')`
    flex-direction: column;
    padding-left: 10px;
    align-items: flex-start;
  `}
`
